import { defineRecipe } from '@chakra-ui/react';

export const codeRecipe = defineRecipe({
  className: 'code',
  base: {
    px: 2,
    py: 1,
    borderRadius: '8px',
    bgColor: 'purple.700',
    fontFamily:
      'monoId, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
  },
});
